import {ClickerGameLayers} from '../../ClickerGame.constants';
import {DI_TOKENS} from '@/di/di.tokens';
import {Sprite, Spritesheet, Texture} from 'pixi.js';

import {injected} from 'brandi';

import {HealthComponent, IGameObject} from '@specials/gcs-engine';

import {PixiViewComponent} from '@/gcs/PixiViewComponent';
import {GameObjectUtils} from '@/utils/GameObjectUtils';

import {ClickerGameAssetsLoader} from '../../ClickerGameAssetsLoader';
import {AsteroidDataComponent, AsteroidType} from './AsteroidDataComponent';

export class AsteroidViewComponent extends PixiViewComponent<Sprite> {
  private dataComponent?: AsteroidDataComponent;
  private healthComponent?: HealthComponent;

  constructor(private readonly assetsLoader: ClickerGameAssetsLoader) {
    super();
  }

  public onAddToGameObject(go: IGameObject): void {
    super.onAddToGameObject(go);

    this.dataComponent = go.getComponent(AsteroidDataComponent);
    this.healthComponent = go.getComponent(HealthComponent);

    this.healthComponent?.subscribeOnChangeHealth(this.handleChangeHealth);
  }

  public renderView(): Sprite {
    const sprite = new Sprite(this.getSpriteByHealth());
    sprite.width = sprite.height = 100;
    sprite.zIndex = ClickerGameLayers.BonusesLayer;
    sprite.anchor.set(0.5);

    return sprite;
  }

  private handleChangeHealth = (): void => {
    if (!this.view) return;

    this.view.texture = this.getSpriteByHealth();
  };

  private getSpriteByHealth(): Texture {
    const type = this.dataComponent?.type;
    const health = this.healthComponent?.health;

    if (type === undefined || health === undefined) throw new Error('asteroid is not initialized');

    const spriteList = this.getSpriteListByType(type);

    return spriteList[health - 1];
  }

  private getSpriteListByType(type: AsteroidType): Texture[] {
    return GameObjectUtils.createFramesFromSpriteSheet(this.getSpriteSheetListByType(type)).reverse();
  }

  private getSpriteSheetListByType(type: AsteroidType): Spritesheet {
    switch (type) {
      case 1:
        return this.assetsLoader.bundle.asteroid1;

      case 2:
        return this.assetsLoader.bundle.asteroid2;
    }
  }
}

injected(AsteroidViewComponent, DI_TOKENS.clickerGameAssetsLoader);
